import {
	updateMenu,
	setupMobileViewport,
	setupScrolling,
} from '../modules/menu';
import { sliders } from '../modules/sliders';
import {
	setupImageFx,
	initScrollingFeatures,
	setInitialScrollPosition,
	siteLoader,
} from '../modules/animations';
import { showHide } from '../modules/show-hide';
import {
	setupActiveSections,
	initPushstate,
} from '../modules/waypoints';

import { mapHeightToggle, map } from '../modules/map';
import { singleProjectFiltering } from '../modules/live-feed';
import BlackBlockTitles from '../modules/black-block-titles';

export default {
	init() {
		// JavaScript to be fired on all pages
		initPushstate();
		updateMenu();
		setupScrolling();
		sliders();
		showHide();
		setupActiveSections();
		setupMobileViewport();
		mapHeightToggle();
		setupImageFx();
		map();
		playVideo();
		setupShareLink();
		siteLoader();
		setupMobileFootnotes();
		singleProjectFiltering();
		responsiveTextArea();
		BlackBlockTitles.init();
	},
	finalize() {
		setInitialScrollPosition();
		initScrollingFeatures();
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
	cleanup() {
		// Cleanup functions
		BlackBlockTitles.unload();
	},
};

function responsiveTextArea()
{
	$('textarea').each(function () {
		$(this).attr('rows', '1');
		this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
	}).on('input', function () {
		this.style.height = 'auto';
		this.style.height = (this.scrollHeight) + 'px';
	});
}

function playVideo()
{
	let videoOverlays = document.querySelectorAll('.media-figure__overlay');

	videoOverlays.forEach((overlay) => {
		overlay.addEventListener('click', (e) => {
			let parent = e.currentTarget.parentNode.parentNode;
			let video = parent.querySelector('iframe');

			let videoHref = video.getAttribute('src');
			videoHref = videoHref.replace('autoplay=0', 'autoplay=1');

			video.setAttribute('src', videoHref);

			setTimeout(() => {
				parent.classList.add('active');
			}, 200 )
		})
	})
}

function setupShareLink()
{
	let shareLink = document.querySelector('.share-link');

	if(!shareLink)
	{
		return;
	}

	shareLink.addEventListener('click', (e) => {
		let target = e.currentTarget;
		let link = target.getAttribute('data-href');

		target.querySelector('span').innerText = 'Copied!';
		navigator.clipboard.writeText(link);

		setTimeout(() => {
			target.querySelector('span').innerText = 'Share';
		}, 400 );
	})
}

function setupMobileFootnotes()
{
	let footnotes = document.querySelectorAll('.footnote-trigger');

	footnotes.forEach((footnote) => {
		footnote.addEventListener('click', () => {
			let parent = footnote.parentNode;

			if(parent.classList.contains('active'))
			{
				parent.classList.remove('active')
			} else if(footnote.classList.contains('footnotes')) {
				parent.classList.add('active');
			}
		})
	})
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js